<template>
  <img src="@/assets/images/logo/logo.png" style="width: 50px !important;" @click="reload">
</template>
<script>
  export default {
    name: 'app', data() {
      return {

      }
    },
    methods: {
      reload(){
        this.$route.push='/';
      }
    }
  }
</script>
